import { TxBuilderConfig } from '../types';

export const defaultConfig: TxBuilderConfig = {
  governance: {
    mainnet: {
      BANDZ_GOVERNANCE_V2: '0xEC568fffba86c094cf06b22134B23074DFE2252c',
      BANDZ_GOVERNANCE_V2_EXECUTOR_SHORT:
        '0x61910EcD7e8e942136CE7Fe7943f956cea1CC2f7',
      BANDZ_GOVERNANCE_V2_EXECUTOR_LONG:
        '0xEE56e2B3D491590B5b31738cC34d5232F378a8D5',
      BANDZ_GOVERNANCE_V2_HELPER: '0x16ff7583ea21055bf5f929ec4b896d997ff35847',
    },
  },
  lendingPool: {
    mainnet: {
      proto: {
        LENDING_POOL: '0x7d2768dE32b0b80b7a3454c06BdAc94A69DDc7A9',
        WBCH_GATEWAY: '0xcc9a0B7c43DC2a5F023Bb9b738E45B0Ef6B06E04',
        FLASH_LIQUIDATION_ADAPTER: '0xE377fB98512D7b04827e56BC84e1838804a8019D',
        REPAY_WITH_COLLATERAL_ADAPTER:
          '0x498c5431eb517101582988fbb36431ddaac8f4b1',
        SWAP_COLLATERAL_ADAPTER: '0x135896DE8421be2ec868E0b811006171D9df802A',
      },
      amm: {
        LENDING_POOL: '0x7937d4799803fbbe595ed57278bc4ca21f3bffcb',
        WBCH_GATEWAY: '0xcc9a0B7c43DC2a5F023Bb9b738E45B0Ef6B06E04',
        FLASH_LIQUIDATION_ADAPTER: '0xE377fB98512D7b04827e56BC84e1838804a8019D',
        REPAY_WITH_COLLATERAL_ADAPTER:
          '0x498c5431eb517101582988fbb36431ddaac8f4b1',
        SWAP_COLLATERAL_ADAPTER: '0x135896DE8421be2ec868E0b811006171D9df802A',
      },
    },
  },
  staking: {
    mainnet: {
      bandz: {
        TOKEN_STAKING: '0x4da27a545c0c5b758a6ba100e3a049001de870f5',
        STAKING_REWARD_TOKEN: '0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9',
        STAKING_HELPER: '0xce0424653fb2fd48ed1b621bdbd60db16b2e388a',
      },
      balancer: {
        TOKEN_STAKING: '0xa1116930326D21fB917d5A27F1E9943A9595fb47',
        STAKING_REWARD_TOKEN: '0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9',
      },
    },
  },
  incentives: {
    mainnet: {
      INCENTIVES_CONTROLLER: '0xd784927Ff2f95ba542BfC824c8a8a98F3495f6b5',
      INCENTIVES_CONTROLLER_REWARD_TOKEN:
        '0x4da27a545c0c5b758a6ba100e3a049001de870f5',
    },
  },
  migrator: {
    mainnet: {
      LEND_TO_AAVE_MIGRATOR: '0x317625234562b1526ea2fac4030ea499c5291de4',
    },
  },
};
